import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let CACHE = null;

export function useTools() {
  const [state, setState] = useState({ tools: CACHE?.tools || [], categories: CACHE?.categories || [] });

  useEffect(() => {
    if (CACHE) return;
    api.get("/tools").then((r) => {
      CACHE = r.data;
      setState(r.data);
    });
  }, []);

  return state;
}
